import { BaseXHR } from 'utils/axios';

export const getInvoicesApi = payload =>
  BaseXHR.$get('stripe/getsInvoice', payload);

export const retryInvoiceApi = payload =>
  BaseXHR.$post('stripe/retryInvoice', payload);
